import { mapState, mapActions } from 'vuex';

import { useDataLoading } from '@mixins/factories';

import ColoredStateBadge from '@components/coloredStateBadge';
import OuterLink from '@components/outerLink';

const dataLoadingOptions = {
  getterName: 'getBasket', searchable: false, paged: false, parameterize: true,
};

const basketJobsHeaders = Object.freeze([
  { text: 'Job ID', value: 'id' },
  { text: 'Outer ID', value: 'outerId' },
  { text: 'Proxy Job ID', value: 'proxyJobId' },
  { text: 'Priority', value: 'priority' },
  { text: 'Quantity', value: 'quantity' },
  { text: 'Printed Count', value: 'printed' },
  { text: 'State', value: 'state' },
  { text: 'Created Date', value: 'created' },
  { text: 'Last Update', value: 'lastUpdate' },
  { text: 'Expires', value: 'expires' },
]);
const basketHistoryHeaders = Object.assign([
  { text: 'Start Date', value: 'start' },
  { text: 'End Date', value: 'end' },
  { text: 'Operator', value: 'operator' },
  { text: 'State', value: 'state' },
  { text: 'Rollback State', value: 'rollbackState' },
  { text: 'Reason', value: 'reason' },
]);

export default {
  name: 'BasketDetails',
  mixins: [
    useDataLoading(dataLoadingOptions),
  ],
  components: {
    ColoredStateBadge,
    OuterLink,
  },
  data() {
    return {
      basketJobsHeaders,
      basketHistoryHeaders,
    };
  },
  computed: {
    ...mapState('baskets', ['basket']),
    ...mapState('locations', ['suffix']),
    basketJobs() {
      return this.basket.jobs || [];
    },
    basketHistory() {
      return this.basket.history || [];
    },
  },
  watch: {
    suffix(newValue) {
      this.$router.push({ name: 'baskets', query: { suffix: newValue, pageNum: '1' } });
    },
  },
  methods: {
    ...mapActions('baskets', ['getBasket']),
    getDimensions(w, h) {
      return w < h ? `${w}×${h}` : `${h}×${w}`;
    },
  },
};
